window.onscroll = function() {
  const nav = document.querySelector('.custom-nav'); // Change to your class
  if (window.pageYOffset > nav.offsetTop) {
    nav.classList.add('sticky');
  } else {
    nav.classList.remove('sticky');
  }
};
